import * as React from 'react'

import { palette } from 'main/ui'
import { SVGResponsive } from 'main/ui'

function DollarSign() {
  return (
    <SVGResponsive height={24} width={24}>
      <path
        d="M14.51 16.424c0-1.536-.847-2.432-2.543-3.04l-.32-.112V9.864c.912.176 1.376.816 1.472 1.648h1.376c-.08-1.584-1.152-2.688-2.848-2.88V7.32h-1.168v1.328c-1.584.208-2.736 1.2-2.736 2.736 0 1.504.992 2.224 2.384 2.72l.352.128v3.664c-.912-.176-1.472-.816-1.584-1.856H7.439c.112 1.808 1.216 2.896 3.04 3.088v1.312h1.168v-1.312c1.584-.16 2.864-1.04 2.864-2.704zM9.2 11.304c0-.688.512-1.232 1.28-1.424v2.96c-.848-.368-1.28-.8-1.28-1.536zm2.448 6.608v-3.248c.992.432 1.392 1.008 1.392 1.792 0 .832-.624 1.312-1.392 1.456z"
        fill={palette.slate}
      />
      <circle cx="11" cy="13" r="10.5" stroke={palette.slate} />
    </SVGResponsive>
  )
}

export default React.memo(DollarSign)
